module.exports = __webpack_public_path__ + "img/p2-49.131d9e54.png";